import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Stack,
  useColorModeValue,
  Text,
  Box,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const UserTermsAndConditions = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  // Theme Colors
  const bgColor = useColorModeValue('teal.600', 'gray.800');
  const textColor = useColorModeValue('custom.900', 'gray.200');
  const boxBgColor = useColorModeValue('gray.50', 'gray.700');
  const boxTextColor = useColorModeValue('custom.800', 'gray.100');

  return (
    <Flex
      minH="100vh"
      direction="column"
      align="center"
      //justify="center"
      bg={bgColor}
      color={textColor}
      width="100%"
      // paddingTop="20px"
      pt={`calc(1rem + env(safe-area-inset-top))`}
    >
      {/* Header */}
      <Box
        display="flex"
        // bg={bgColor}
        alignItems="center"
        p={2}
        mb={4}
        width="100%"
      >
        <FontAwesomeIcon
          onClick={() => navigate('/')}
          icon={faArrowLeft}
          size="xl"
          style={{ cursor: 'pointer', marginRight: '8px' }}
        />
        <Text align="left" fontSize="xl" fontWeight="bold" ml={2}>
          {t('menu.items.terms_conditions')}
        </Text>
      </Box>
  
      {/* Main Content */}
      <Box 
        minH={'110vh'}
        w="full"
        maxW="lg"
        borderRadius="2xl"
        bg={boxBgColor}
        color={boxTextColor}
        p={3}
        >
        <Stack
            h="calc(120vh)" // Accounts for padding (3 = 12px * 2)
            w="full"
            overflowY="auto"
            pr={2} // Prevents text from touching scrollbar
            spacing={3} // Adds consistent spacing between sections
            // css={{
            // '&::-webkit-scrollbar': {
            //     width: '6px',
            // },
            // '&::-webkit-scrollbar-thumb': {
            //     backgroundColor: 'gray.500',
            //     borderRadius: '3px',
            // },
            // }}
            >
            <Text fontWeight="bold" fontSize="xs">
              {t('reward_terms.title')}
            </Text>
            <Text fontSize={'xs'} mb={4}> {/* Added bottom margin */}
              {t('reward_terms.title2')}
            </Text>

            {[1, 2, 3, 4, 5, 6, 7].map((section) => (
            <Box key={section}>
                <Text fontWeight="bold" fontSize="xs">
                {t(`reward_terms.section${section}_header`)}
                </Text>
                <Text fontSize={'xs'} mb={4}> {/* Added bottom margin */}
                {t(`reward_terms.section${section}`)}
                </Text>
            </Box>
            ))}
        </Stack>
      </Box>
    </Flex>
  );  
};

export default UserTermsAndConditions;